/* eslint-disable react/forbid-dom-props */
import React from 'react'

interface Props {
  width?: number
  height?: number
}

export const PieNoShadowIcon: React.FC<Props> = ({
  width = 228,
  height = 184,
}) => (
  <svg
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={width}
    height={height}
    viewBox="0 0 228 184"
  >
    <defs>
      <filter
        id="pie_no_shadow_b"
        width="101.8%"
        height="103.4%"
        x="-.9%"
        y="-1.7%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy="-4" in="SourceAlpha" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          in="shadowInnerInner1"
          values="0 0 0 0 0.89342731 0 0 0 0 0.89342731 0 0 0 0 0.89342731 0 0 0 1 0"
        />
      </filter>
      <filter
        id="pie_no_shadow_c"
        width="232.8%"
        height="228.8%"
        x="-66.4%"
        y="-64.4%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy="17" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="13.5"
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter
        id="pie_no_shadow_f"
        width="101.6%"
        height="100.5%"
        x="-.8%"
        y="-.8%"
        filterUnits="objectBoundingBox"
      >
        <feGaussianBlur
          in="SourceAlpha"
          result="shadowBlurInner1"
          stdDeviation=".5"
        />
        <feOffset
          dx="1"
          dy="-1"
          in="shadowBlurInner1"
          result="shadowOffsetInner1"
        />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          in="shadowInnerInner1"
          values="0 0 0 0 0.85436481 0 0 0 0 0.552928515 0 0 0 0 0.117117005 0 0 0 0.790947334 0"
        />
      </filter>
      <filter
        id="pie_no_shadow_i"
        width="103.9%"
        height="105.5%"
        x="-2%"
        y="-2.7%"
        filterUnits="objectBoundingBox"
      >
        <feGaussianBlur
          in="SourceAlpha"
          result="shadowBlurInner1"
          stdDeviation="2"
        />
        <feOffset
          dx="-1"
          dy="-1"
          in="shadowBlurInner1"
          result="shadowOffsetInner1"
        />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          in="shadowInnerInner1"
          values="0 0 0 0 0.780392157 0 0 0 0 0.501960784 0 0 0 0 0.278431373 0 0 0 0.317498907 0"
        />
      </filter>
      <filter
        id="pie_no_shadow_l"
        width="103.3%"
        height="104.8%"
        x="-1.6%"
        y="-2.1%"
        filterUnits="objectBoundingBox"
      >
        <feGaussianBlur
          in="SourceAlpha"
          result="shadowBlurInner1"
          stdDeviation="2"
        />
        <feOffset in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          in="shadowInnerInner1"
          result="shadowMatrixInner1"
          values="0 0 0 0 1 0 0 0 0 0.71017264 0 0 0 0 0 0 0 0 0.535183566 0"
        />
        <feGaussianBlur
          in="SourceAlpha"
          result="shadowBlurInner2"
          stdDeviation=".5"
        />
        <feOffset in="shadowBlurInner2" result="shadowOffsetInner2" />
        <feComposite
          in="shadowOffsetInner2"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner2"
        />
        <feColorMatrix
          in="shadowInnerInner2"
          result="shadowMatrixInner2"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.475497159 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixInner1" />
          <feMergeNode in="shadowMatrixInner2" />
        </feMerge>
      </filter>
      <filter
        id="pie_no_shadow_o"
        width="103.1%"
        height="109%"
        x="-1.1%"
        y="-4.5%"
        filterUnits="objectBoundingBox"
      >
        <feGaussianBlur
          in="SourceAlpha"
          result="shadowBlurInner1"
          stdDeviation="2"
        />
        <feOffset
          dx="-1"
          dy="-1"
          in="shadowBlurInner1"
          result="shadowOffsetInner1"
        />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          in="shadowInnerInner1"
          values="0 0 0 0 1 0 0 0 0 0.876656309 0 0 0 0 0.562690549 0 0 0 0.748333698 0"
        />
      </filter>
      <filter
        id="pie_no_shadow_p"
        width="103.8%"
        height="103.8%"
        x="-1%"
        y="-1%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dx="1" dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feColorMatrix
          in="shadowOffsetOuter1"
          values="0 0 0 0 0.708248415 0 0 0 0 0.406680315 0 0 0 0 0.00163296605 0 0 0 0.444192526 0"
        />
      </filter>
      <filter
        id="pie_no_shadow_s"
        width="125%"
        height="124.8%"
        x="-11.5%"
        y="-11.5%"
        filterUnits="objectBoundingBox"
      >
        <feGaussianBlur
          in="SourceAlpha"
          result="shadowBlurInner1"
          stdDeviation="2"
        />
        <feOffset dy="-4" in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          in="shadowInnerInner1"
          result="shadowMatrixInner1"
          values="0 0 0 0 0.956862745 0 0 0 0 0.752941176 0 0 0 0 0.368627451 0 0 0 0.924797858 0"
        />
        <feGaussianBlur
          in="SourceAlpha"
          result="shadowBlurInner2"
          stdDeviation=".5"
        />
        <feOffset dy="-11" in="shadowBlurInner2" result="shadowOffsetInner2" />
        <feComposite
          in="shadowOffsetInner2"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner2"
        />
        <feColorMatrix
          in="shadowInnerInner2"
          result="shadowMatrixInner2"
          values="0 0 0 0 0.956862745 0 0 0 0 0.752941176 0 0 0 0 0.368627451 0 0 0 0.2 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixInner1" />
          <feMergeNode in="shadowMatrixInner2" />
        </feMerge>
      </filter>
      <linearGradient
        id="pie_no_shadow_g"
        x1="3.393%"
        x2="100%"
        y1="37.914%"
        y2="66.449%"
      >
        <stop offset="0%" stopColor="#FFE3C1" />
        <stop offset="100%" stopColor="#EAC380" />
      </linearGradient>
      <linearGradient
        id="pie_no_shadow_j"
        x1="13.026%"
        x2="91.397%"
        y1="27.58%"
        y2="64.145%"
      >
        <stop offset="0%" stopColor="#DB6C2F" />
        <stop offset="100%" stopColor="#FFB65C" />
      </linearGradient>
      <linearGradient
        id="pie_no_shadow_m"
        x1="97.929%"
        x2="8.71%"
        y1="60.372%"
        y2="48.826%"
      >
        <stop offset="0%" stopColor="#FFB570" />
        <stop offset="100%" stopColor="#FFA94D" />
      </linearGradient>
      <linearGradient
        id="pie_no_shadow_r"
        x1="71.895%"
        x2="56.218%"
        y1="11.829%"
        y2="56.723%"
      >
        <stop offset="0%" stopColor="#FFF" />
        <stop offset="100%" stopColor="#F9F9EF" />
      </linearGradient>
      <linearGradient
        id="pie_no_shadow_t"
        x1="55.204%"
        x2="92.377%"
        y1="54.503%"
        y2="12.466%"
      >
        <stop offset="0%" stopColor="#FCF6E6" />
        <stop offset="100%" stopColor="#F0CA81" />
      </linearGradient>
      <path
        id="pie_no_shadow_e"
        d="M3.572 98.196l118.415 31.686a4.498 4.498 0 005.661-4.345v-9.77L9.313 88.935l-1.87-39.214 81.926-20.724c-.732-11.966-4.952-17.183-12.66-15.652-2.392.476-7.113 4.865-13.097 6.186-4.363.963-9.398-1.317-14.691 0-3.94.98-8.021 5.938-12.076 7.076-4.355 1.222-8.678-1.365-12.759 0-4.56 1.524-8.815 6.309-12.472 7.957C4.169 37.92.236 37.494.236 41v52.85a4.499 4.499 0 003.336 4.345z"
      />
      <path
        id="pie_no_shadow_h"
        d="M127.627 40.858v52.85a4.498 4.498 0 01-3.335 4.345L5.876 129.74a4.497 4.497 0 01-5.661-4.345v-9.77l118.336-26.831 1.87-39.214-1.074-.272 7.204-10.772c.713.555 1.076 1.258 1.076 2.323z"
      />
      <path
        id="pie_no_shadow_k"
        d="M.402 50.068l1.106 38.393a4.5 4.5 0 003.366 4.225l115.771 30.061V84.018L2.007 48.834a1.25 1.25 0 00-1.605 1.234z"
      />
      <path
        id="pie_no_shadow_n"
        d="M83.63 28.998c-13.403-.796-25.328.052-35.777 2.545-10.188 2.431-25.496 8.174-45.925 17.23a.626.626 0 00.082 1.172l119.783 34.073-38.163-55.02z"
      />
      <path
        id="pie_no_shadow_q"
        d="M29.275 0c14.56 9.273 22.238 19.372 23.033 30.297.175 1.094.235 2.21.171 3.344-.623 11.03-12.759 19.407-27.106 18.71C11.17 51.661.125 42.336.51 31.447l-.007-.405-.01.039c.05-.391.08-.783.147-1.163.24-1.799.79-3.517 1.606-5.127 2.823-5.94 8.669-9.938 17.537-11.992l.27-.062C31.923 10.06 34.997 5.814 29.275 0z"
      />
      <radialGradient
        id="pie_no_shadow_d"
        cx="51.378%"
        cy="50%"
        r="79.107%"
        fx="51.378%"
        fy="50%"
        gradientTransform="scale(.92857 1) rotate(-24.989 .534 .41)"
      >
        <stop offset="0%" stopColor="#F2D4A0" />
        <stop offset=".889%" stopColor="#FFCE92" />
        <stop offset="100%" stopColor="#F4D3A0" />
      </radialGradient>
      <ellipse
        id="pie_no_shadow_a"
        cx="113.478"
        cy="58.758"
        rx="113.478"
        ry="58.758"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(.174 52.557)">
        <use fill="#FAFAFA" xlinkHref="#pie_no_shadow_a" />
        <use
          fill="#000"
          filter="url(#pie_no_shadow_b)"
          xlinkHref="#pie_no_shadow_a"
        />
        <ellipse cx="113.478" cy="58.867" fill="#EEE" rx="72.342" ry="30.497" />
      </g>
      <g filter="url(#pie_no_shadow_c)" transform="rotate(-7 129.98 -372.877)">
        <g transform="matrix(-1 0 0 1 127.885 0)">
          <use fill="url(#pie_no_shadow_d)" xlinkHref="#pie_no_shadow_e" />
          <use
            fill="#000"
            filter="url(#pie_no_shadow_f)"
            xlinkHref="#pie_no_shadow_e"
          />
        </g>
        <use fill="url(#pie_no_shadow_g)" xlinkHref="#pie_no_shadow_h" />
        <use
          fill="#000"
          filter="url(#pie_no_shadow_i)"
          xlinkHref="#pie_no_shadow_h"
        />
        <g transform="matrix(-1 0 0 1 120.998 0)">
          <use fill="url(#pie_no_shadow_j)" xlinkHref="#pie_no_shadow_k" />
          <use
            fill="#000"
            filter="url(#pie_no_shadow_l)"
            xlinkHref="#pie_no_shadow_k"
          />
        </g>
        <g transform="matrix(-1 0 0 1 122.146 0)">
          <use fill="url(#pie_no_shadow_m)" xlinkHref="#pie_no_shadow_n" />
          <use
            fill="#000"
            filter="url(#pie_no_shadow_o)"
            xlinkHref="#pie_no_shadow_n"
          />
        </g>
        <g transform="rotate(-4 80.713 -604.972)">
          <use
            fill="#000"
            filter="url(#pie_no_shadow_p)"
            xlinkHref="#pie_no_shadow_q"
          />
          <use fill="url(#pie_no_shadow_r)" xlinkHref="#pie_no_shadow_q" />
          <use
            fill="#000"
            filter="url(#pie_no_shadow_s)"
            xlinkHref="#pie_no_shadow_q"
          />
          <path
            fill="#F9F9EF"
            d="M29.275 0c.596.41.978.822 1.55 1.235 3.49 2.794 4.154 7.523 2.18 10.944-3.013 5.218-24.123 5.137-29.108 12.862l.116-.25c2.618-5.94 8.037-9.938 16.26-11.992l.25-.062C31.527 10.06 34.58 5.814 29.274 0z"
          />
          <path
            fill="url(#pie_no_shadow_t)"
            d="M29.275 0l.175.195c5.06 5.714 1.954 9.895-8.928 12.542l-.25.062c-7.654 1.912-12.88 5.509-15.677 10.79 2.53-5.476 7.407-9.911 14.632-13.307C27.134 6.565 30.483 3.138 29.275 0z"
          />
        </g>
      </g>
    </g>
  </svg>
)
